export const name = 'gzMouseWheelDown';

/**
 * @ngdoc directive
 * @name gazelle.components.mouse.wheelDown.directive:gzMouseWheelDown
 *
 * @description
 * `<gz-mouse-wheel-down>` captures wheel down events.
 *
 * @usage
 * ```html
 * <div gz-mouse-wheel-down='vm.wheelDown()'>
 *
 * ```
 */
export default function gzMouseWheelDown($compile,$window) {
  //noinspection BadExpressionStatementJS
  'ngInject';


  var directive = {
    restrict: 'EA',
    link: gzMouseDownLink,
  };

  return directive;

  //////////////////////
  // Private functions
  function gzMouseDownLink(scope, element, attrs) {
    element.bind('DOMMouseScroll mousewheel onmousewheel', (ev) => {
      let prevent = false;
      if (attrs.gzMouseWheelPrevent) {
        prevent = scope.$eval(attrs.gzMouseWheelPrevent);
      }

      if (!prevent) {
        let event = $window.event || ev;
        let delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        if (delta < 0) {
          scope.$apply(() => {
            scope.$eval(attrs.gzMouseWheelDown);
          });
        }

        if (event.preventDefault) {
          event.preventDefault();
        }

        // for IE
        event.returnValue = false;
      }
    });
  }
}
